const appConstants = {
        default_dummay_email: 'artefy.dummy.com',
        artefyUser: 'artefyUser'
};
export default appConstants;
  